// extracted by mini-css-extract-plugin
export default {"button":"uploadButton_button__u1v4M","fileInput":"uploadButton_fileInput__ZTZMz"};